<template>
  <div>
    <q-dialog 
      :visible="isVisible"
      :title="title"
      width="600px"
      :innerScroll="false"
      :offsetHeight="170"
      @close="onCancel"
      @cancel="onCancel"
    >
      <el-form :model="form" ref="ruleForm" label-width="125px" class="demo-ruleForm">
        <template v-for="(item,index) in formItems">
          <template v-if="item.type != 'select' && item.type != 'int' && item.type != 'radio' ">
            <el-form-item v-bind="item" :key="index">
              <el-input v-bind="item.inputConf" :type="item.type" :style="{width: InputWidth}" size="small" placeholder="请输入" v-model="form[item.field]"></el-input>
            </el-form-item>
          </template>
          <template v-if="item.type == 'int' ">
            <el-form-item v-bind="item" :key="index">
              <el-input v-bind="item.inputConf" oninput="this.value=this.value.replace(/[^0-9]/g,'')" :type="item.type" :style="{width: InputWidth}" size="small" placeholder="请输入" v-model="form[item.field]"></el-input>
            </el-form-item>
          </template>
          <template v-if="item.type === 'select'">
            <el-form-item v-bind="item" :key="index">
              <el-select v-model="form[item.field]" size="small">
                <el-option  v-bind="obj" v-for="(obj,index1) in item.options.select" :key="index1">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-if="item.type === 'radio'">
            <el-form-item v-bind="item" :key="index">
              <el-radio-group v-model="form[item.field]">
                <el-radio 
                  :label="obj.label" 
                  v-for="obj in item.options.select"
                  :key="obj.label"
                >
                  {{ obj.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </template>
        
      </el-form> 
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onConfirm">确定并更新缓存</el-button>
        </span>
      </template>
    </q-dialog>
  </div>
</template>

<script>
import qDialog from '@/components/qDialog/qDialog'
export default {
  components: {
    qDialog
  },
  props: {
    isNewAddPopup: {
      type: Boolean,
      default: false
    },
    InputWidth: {
      style: String,
      default: '220px'
    },
    formItems: {
      type: Array,
      default() {
        return []
      }
    },
    editData: {
      type: Object,
      default() {
        return {}
      }
    },
    title: {
      type: String,
      default: '新增'
    }
  },
  computed: {
    isVisible: {
      get() {
        // if (this.form.liveRoomId) this.title = '编辑'
        return this.isNewAddPopup
      },
      set(newVal) {
        this.$emit('update:isNewAddPopup',newVal)
      }
    },
    form: {
      get() {
        return this.editData
      },
      set(newVal) {
        this.$emit('update:editData', newVal)
      }
    }
  },
  data() {
    return {
      // title: '新增',
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
    },
    onConfirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$emit('onConfirm')
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  // .date-input
  //   width 220px !important
</style>
